import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import { Messages } from '../Messages/Messages';
import { INVITATION_STATUSES } from '../../../config/constants';
import {
  ListGroup,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Row,
  Col
} from 'reactstrap';
import { Notification } from './Notification';

class NotificationsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = ({
      isDropdownOpen: false
    });
  }

  toggleDropdown = () => {
    let isDropdownOpen = this.state.isDropdownOpen;
    this.setState({
      isDropdownOpen: !isDropdownOpen
    });
  }

  render() {
    let nrNewInvitations = 0;
    let pendingNotifications = [];
    let updatedNotifications = [];
    // sort by status
    this.props.notifications.forEach(invitation => {
      if (invitation.status === INVITATION_STATUSES.PENDING) {
        nrNewInvitations++;
        pendingNotifications.push(invitation);
      }
    });

    // Sort pending notifications bt created date
    let sortedPendingNotifications = pendingNotifications.sort(function (a, b) {
      return moment(b.created_at).diff(a.created_at);
    });

    // sort by updated invitations
    this.props.notifications.forEach(invitation => {
      if (invitation.status !== INVITATION_STATUSES.PENDING) {
        updatedNotifications.push(invitation);
      }
    });

    // Sort updated notifications bt updated date
    let sortedUpdatedNotifications = updatedNotifications.sort(function (a, b) {
      return moment(b.updated_at).diff(a.updated_at);
    });

    let notifications = [];
    notifications = notifications.concat(sortedPendingNotifications).concat(sortedUpdatedNotifications);

    return (

      <UncontrolledDropdown nav isOpen={ this.state.isDropdownOpen } toggle={() => this.toggleDropdown()}>
        <DropdownToggle className="nav-link cursor-pointer notifications-bell" color="" tag="a">
          <div className="notifications-number">{nrNewInvitations}</div>
          <i className="ni ni-bell-55" />
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-xl  py-0 overflow-hidden"
          right
        >
          <div className="px-3 py-3 border-bottom">
            <Row>
              <Col>
                <Messages className="m-3" />
                <h3 className="m-0">
                  <FormattedMessage
                    id="components.layout.navbars.notifications.number_of_notifications"
                    values={{ notificationsCount: (<strong className="color-primary">{nrNewInvitations}</strong>) }}
                  />
                </h3>
              </Col>
            <button className="close mr-2" type="button" onClick={() => this.toggleDropdown()}>
              <span aria-hidden="true">×</span>
            </button>
            </Row>
          </div>

          <ListGroup flush className="notification-body">
            {
              notifications.map(
                (notification, index) => (
                  <Notification notification={notification} key={index} index={index} />
                )
              )
            }
          </ListGroup>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

NotificationsComponent.defaultProps = {
  notifications: [],
};

const mapStateToProps = state => ({
  notifications: state && state.organization && state.organization.notifications
});

const Notifications = connect(mapStateToProps, null)(NotificationsComponent);
export { Notifications };

